import { render, staticRenderFns } from "./DlgEditFolderName.vue?vue&type=template&id=fca88e24&scoped=true"
import script from "./DlgEditFolderName.vue?vue&type=script&lang=js"
export * from "./DlgEditFolderName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca88e24",
  null
  
)

export default component.exports